import { logApiFailureEvent } from "@src/lib/analytics";
import { AddressBody, AddressResponse } from "@src/lib/interface";
import {
  WorkerServiceEndpoints,
  getWorkerServiceMappedURL,
} from "@src/utils/worker-service/worker-service.utils";
import request from "superagent";
import timezoneLookup from "tz-lookup";

import { getAuthHeader } from "../superagent";

const updateAddress = async (address: AddressBody): Promise<AddressResponse | undefined> => {
  try {
    const updateAgentAddress = getWorkerServiceMappedURL(
      WorkerServiceEndpoints.UPDATE_WORKER_PROFILE_ADDRESS
    );
    const tmz = timezoneLookup(address.location?.lat, address.location?.lng);
    const { body, status } = await request
      .post(updateAgentAddress)
      .set(await getAuthHeader())
      .send({ ...address, tmz });
    return { ...body, status };
  } catch (error) {
    logApiFailureEvent(error);
  }
};

export { updateAddress };
